import { getBaseurl } from "@/utils/url-parse";
import { API } from "@akc/biz-api";
import { AddressVo, GiftDetailVo } from "./types.d";

export const queryGiftApi = async (params: { orderNo: string }) => {
  return API.post<GiftDetailVo>({
    path: `${getBaseurl()}/api/order/gift/detail`,
    body: params,
  });
};

export const openGiftApi = async (params: { orderGroupNo: string; orderNo: string }) => {
  return API.post({
    path: `${getBaseurl()}/api/order/gift/open`,
    body: params,
  });
};

export const receiveGiftApi = async (params: {
  orderGroupNo: string;
  orderNo: string;
  addressId: string;
  modifySkuInfos?: {
    skuId: string;
    currentSkuId: string;
    activityId: string;
  }[];
}) => {
  return API.post({
    path: `${getBaseurl()}/api/order/gift/receive`,
    body: params,
  });
};

export const queryAddressListApi = async () => {
  return API.get<AddressVo[]>({
    path: `${getBaseurl()}/api/member/xdwxh5/member/address/list`,
  });
};

export const updateAddressApi = async (params: AddressVo) => {
  return API.post({
    path: `${getBaseurl()}/api/member/xdwxh5/member/address/update`,
    body: params,
  });
};

export const removeAddressApi = async (addressId: string) => {
  return API.post({
    path: `${getBaseurl()}/api/member/xdwxh5/member/address/delete/${addressId}`,
    body: { id: addressId },
  });
};

export const queryProductDetailApi = async (params: {
  activityId: string;
  activitySpuId: string;
  pageId: "H5_ProductDetail";
  selectSkuId: string;
}) => {
  return API.post<GiftDetailVo>({
    path: `${getBaseurl()}/api/mshop/mshop-aggr-prod/outer/product/info`,
    body: params,
  });
};
